module.exports = __webpack_public_path__ + "img/mr.4610ac53.svg";